import { ProductApiModel } from '~/lib/api/smartsend/types';
import { TariffCode } from '../customs/TariffCode';
import { DimensionAndWeightDisplay } from '../smartsend/DimensionDisplay';
import { ProductImage } from './ProductImage';
import { P2GBox, P2GDivider, P2GLink, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  products: ProductApiModel[];
  onSelect: (p: ProductApiModel) => void;
}
export const ProductList: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <P2GBox bordered>
      {props.products.map((x) => (
        <P2GBox key={x.Id}>
          <P2GBox p={1} onClick={() => props.onSelect(x)}>
            <P2GGrid container wrap="nowrap" alignItems="center" gap={2}>
              <P2GGrid item flexShrink={1}>
                <ProductImage product={x} />
              </P2GGrid>
              <P2GGrid item flexGrow={1}>
                <P2GBox>
                  <P2GText>
                    <strong>{x.Description}</strong>
                  </P2GText>
                </P2GBox>
                <P2GBox>
                  <DimensionAndWeightDisplay dimensions={x.Dimensions} />
                </P2GBox>
                {x.TariffCode && (
                  <P2GBox>
                    <TariffCode selectable={true} code={x.TariffCode} />
                  </P2GBox>
                )}
              </P2GGrid>
              <P2GGrid item flexShrink={1}>
                <P2GLink>{t('SELECT_TOOLTIP_BUTTON', { defaultValue: 'Select' })}</P2GLink>
              </P2GGrid>
            </P2GGrid>
          </P2GBox>
          <P2GDivider />
        </P2GBox>
      ))}
    </P2GBox>
  );
};
